import { createSlice, createAsyncThunk } from "@reduxjs/toolkit"
import ProspectService from "services/ProspectService"

export const createProspect = createAsyncThunk(
  "prospects/create",
  async (data, { rejectWithValue }) => {
    try {
      const response = await ProspectService.create(data)
      return response
    } catch (error) {
      if (error?.response?.status === 409) {
        return rejectWithValue(error.response.data.error)
      }
      return rejectWithValue("Erreur serveur")
    }
  }
)

export const fetchProspects = createAsyncThunk(
  "prospects/fetchAll",
  async (params = {}, { rejectWithValue }) => {
    try {
      const response = await ProspectService.getAll(params)
      return response
    } catch (error) {
      return rejectWithValue("Erreur serveur")
    }
  }
)

export const countNewProspects = createAsyncThunk(
  "prospects/countNewProspects",
  async (_, { rejectWithValue }) => {
    try {
      const response = await ProspectService.countNewProspects()
      return response
    } catch (error) {
      return rejectWithValue("Erreur serveur")
    }
  }
)

export const updateStatus = createAsyncThunk(
  "prospects/updateStatus",
  async ({ id, status }, { rejectWithValue }) => {
    try {
      const response = await ProspectService.updateStatus(id, status)
      return { id, status }
    } catch (error) {
      return rejectWithValue("Erreur serveur")
    }
  }
)

export const deleteProspect = createAsyncThunk(
  "prospects/delete",
  async (id, { rejectWithValue }) => {
    try {
      const response = await ProspectService.delete(id)
      return { id }
    } catch (error) {
      return rejectWithValue("Erreur serveur")
    }
  }
)
const prospectSlice = createSlice({
  name: "prospects",
  initialState: {
    list: [],
    loading: false,
    error: null,
    successMessage: null,
    pagination: {
      page: 1,
      total: 0,
      totalPages: 0,
    },
    countProspects: {
      data: null,
      error: null,
      loading: false,
    },
    updateStatus: {
      data: null,
      loading: false,
    },
  },
  reducers: {
    clearMessages: (state) => {
      state.error = null
      state.successMessage = null
    },
  },
  extraReducers: (builder) => {
    builder
      // CREATE
      .addCase(createProspect.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(createProspect.fulfilled, (state, action) => {
        state.loading = false
        state.successMessage = "Prospect créé avec succès ✅"
        state.list.unshift(action.payload) // ajouter en tête
      })
      .addCase(createProspect.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload // message d’erreur du backend (409)
      })

      // GET ALL
      .addCase(fetchProspects.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(fetchProspects.fulfilled, (state, action) => {
        state.loading = false
        state.list = action.payload.data
        state.pagination = {
          page: action.payload.page,
          total: action.payload.total,
          totalPages: action.payload.totalPages,
        }
      })
      .addCase(fetchProspects.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload
      })

      .addCase(countNewProspects.pending, (state) => {
        state.countProspects.loading = true
        state.countProspects.error = null
      })
      .addCase(countNewProspects.fulfilled, (state, action) => {
        state.countProspects.loading = false
        state.countProspects.data = action.payload
      })
      .addCase(countNewProspects.rejected, (state, action) => {
        state.countProspects.loading = false
        state.countProspects.error = action.payload
      })

      //

      .addCase(updateStatus.pending, (state) => {
        state.updateStatus.loading = true
      })
      .addCase(updateStatus.fulfilled, (state, action) => {
        state.updateStatus.loading = false

        const { id, status } = action.payload

        // 🔎 Debug : voir les valeurs reçues
        console.log("UpdateStatus payload:", action.payload)
        console.log(
          "Liste actuelle:",
          state.list.map((p) => ({ id: p.id, status: p.status }))
        )

        state.list = state.list.map((prospect) => {
          if (prospect.id === id) {
            console.log("Prospect trouvé et mis à jour:", prospect.id)
            return { ...prospect, status }
          }
          return prospect
        })
      })
      .addCase(updateStatus.rejected, (state, action) => {
        state.updateStatus.loading = false
      })
  },
})

export const { clearMessages } = prospectSlice.actions

export default prospectSlice.reducer
